import {
  Indicator
} from 'mint-ui'

const domain = 'https://data-api.sanmanuela.net/api'
const prefix = {
  app: 'fytv',
  device: 'mobile',
  version: '1.1.0'
}
export default class BaseApi {
  install(Vue) {
    this._http = Vue.http
  }

  postRequest(response, url) {
    return response
  }

  async sendHttpRequest(method, url, {
    body,
    params,
    headers
  }) {
    try {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      if (url.indexOf('//') == -1) {
        url = domain + url
      }
      params = Object.assign({}, prefix, params)
      let response = await this._http({
        method,
        url,
        body,
        params,
        headers
      })
      return this.postRequest(response.body, url)
    } finally {
      Indicator.close()
    }
  }

  httpJsonp(url, params) {
    return this.sendHttpRequest('jsonp', url, {
      params
    })
  }

  httpGet(url, params) {
    return this.sendHttpRequest('get', url, {
      params
    })
  }

  httpPost(url, body, params) {
    return this.sendHttpRequest('post', url, {
      body,
      params
    })
  }

  httpPut(url, body, params) {
    return this.sendHttpRequest('put', url, {
      body,
      params
    })
  }

  httpPatch(url, body, params) {
    return this.sendHttpRequest('patch', url, {
      body,
      params
    })
  }

  httpDelete(url, params) {
    return this.sendHttpRequest('delete', url, {
      params
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/api/BaseApi.js